import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};

export default new Vuex.Store({
  state: {
    posX: 50,
    site: [],
    home: [],
    articles: [],
    glossary: [],
    about: [],
  },
  getters: {
    getArticleByUID:
      (state) =>
      (uid, collection = state.articles) => {
        let i = collection.length;
        while (i--) {
          if (collection[i].uid === uid) {
            return collection[i];
          }
        }
      },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              description: "site.seoDescription.kirbytext",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home')",
            select: {
              title: true,
              uid: true,
              english: "page.text",
              chinese: "page.chinese",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_HOME", response.data.result);
        });
    },
    async loadArticles({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('articles').children.listed",
            select: {
              title: true,
              uid: true,
              author: true,
              date: "page.date.toDate('d.m.Y')",
              english: "page.text",
              template: "page.intendedTemplate",
              chinese: "page.chinese",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_ARTICLES", response.data.result.data);
        });
    },
    async loadGlossary({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('glossary')",
            select: {
              title: true,
              uid: true,
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_GLOSSARY", response.data.result);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              english: "page.text",
              chinese: "page.chinese",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_ABOUT", response.data.result);
        });
    },
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_HOME(state, home) {
      state.home = home;
    },
    SET_ARTICLES(state, pages) {
      state.articles = pages;
    },
    SET_GLOSSARY(state, pages) {
      state.glossary = pages;
    },
    SET_ABOUT(state, pages) {
      state.about = pages;
    },
  },
});
